import { useGetContextPPGDaljab } from 'api/useAPIPPGDaljab'

import { getSession } from 'utils/auth'
import { useLocalStorage } from 'utils/hooks/useLocalStorage'

export const usePPGDaljabHook = () => {
  const { isLoading, isError, data, isEligible } = useGetContextPPGDaljab()
  const getPpgDaljabValue = useLocalStorage('ppg-daljab-confirmed-user', '')
  const session = getSession()
  const userId = session?.user?.id

  return {
    isLoading,
    isEligible,
    isError,
    isConfirmed: getPpgDaljabValue[0] === userId,
    data: data,
    setConfirmed: () => getPpgDaljabValue[1](userId),
  }
}
